import { IPagination } from '../types/pagination'
import { IProject } from '../views/project/types/project'
import { IDepartmentUtilizationFilterData,
  IGlobalReportDepartmentUtilizationData,
  IGlobalReportExpectedPaymentsData,
  IGlobalReportExpenditurePhasingData,
  IGlobalReportHoursPhasingData,
  IProjectList,
  IProjectListFilterData,
  IReport,
  ITasksByProject,
  ITasksByProjectFilterData
} from '../views/reports/types/reports'
import { IFTEByProject, IProjectHoursPhasingFilterData, IReportChart } from './../views/reports/types/reports'
import { HttpClient } from './service'
import Urls from './urls'
import { AxiosResponse } from 'axios'

export const ReportsApi = {
  getReports(queryParams: Record<string, string>): Promise<IReport[]> {
    return HttpClient.get<IReport[], Record<string, string>>(Urls.GlobalReport.reports, queryParams)
  },

  getTasksByProjectFilterData(queryParams: Record<string, string>): Promise<ITasksByProjectFilterData> {
    return HttpClient.get<ITasksByProjectFilterData, Record<string, string>>(`${Urls.GlobalReport.reports}tasks-by-project-filter`, queryParams)
  },

  getTasksByProject(queryParams: Record<string, string>): Promise<IPagination<ITasksByProject[]>> {
    return HttpClient.get<IPagination<ITasksByProject[]>, Record<string, string>>(`${Urls.GlobalReport.reports}tasks-by-project`, queryParams)
  },

  getProjectListFilterData(queryParams: Record<string, string>): Promise<IProjectListFilterData> {
    return HttpClient.get<IProjectListFilterData, Record<string, string>>(`${Urls.GlobalReport.reports}project-list-filter`, queryParams)
  },

  getProjectList(queryParams: Record<string, string>): Promise<IPagination<IProject[]>> {
    return HttpClient.get<IPagination<IProject[]>, Record<string, string>>(`${Urls.GlobalReport.reports}project-list`, queryParams)
  },

  getFTEByProjectFilterData(): Promise<IProjectList> {
    return HttpClient.get<IProjectList, null>(`${Urls.GlobalReport.reports}fte-by-project-filter`)
  },

  getFTEByProject(queryParams: Record<string, string>): Promise<IFTEByProject> {
    return HttpClient.get<IFTEByProject, Record<string, string>>(`${Urls.GlobalReport.reports}fte-by-project`, queryParams)
  },

  getExpenditurePhasing(queryParams: Record<string, string>): Promise<IGlobalReportExpenditurePhasingData> {
    return HttpClient.get<IGlobalReportExpenditurePhasingData, Record<string, string>>(`${Urls.GlobalReport.reports}expenditure-phasing-table`, queryParams)
  },

  getExpenditurePhasingChart(queryParams: Record<string, string>): Promise<IReportChart> {
    return HttpClient.get<IReportChart, Record<string, string>>(`${Urls.GlobalReport.reports}expenditure-phasing-chart`, queryParams)
  },

  getDepartmentUtilizationFilterData(queryParams: Record<string, string>): Promise<IDepartmentUtilizationFilterData> {
    return HttpClient.get<IDepartmentUtilizationFilterData, Record<string, string>>(`${Urls.GlobalReport.reports}department-utilization-filter`, queryParams)
  },

  getDepartmentUtilization(queryParams: Record<string, string>): Promise<IGlobalReportDepartmentUtilizationData> {
    return HttpClient.get<IGlobalReportDepartmentUtilizationData, Record<string, string>>(`${Urls.GlobalReport.reports}department-utilization-table`, queryParams)
  },

  getDepartmentUtilizationChart(queryParams: Record<string, string>): Promise<IReportChart> {
    return HttpClient.get<IReportChart, Record<string, string>>(`${Urls.GlobalReport.reports}department-utilization-chart`, queryParams)
  },

  getProjectHoursPhasingFilterData(queryParams: Record<string, string>): Promise<IProjectHoursPhasingFilterData> {
    return HttpClient.get<IProjectHoursPhasingFilterData, Record<string, string>>(`${Urls.GlobalReport.reports}project-hours-phasing-filter`, queryParams)
  },

  getProjectHoursPhasing(queryParams: Record<string, string>): Promise<IGlobalReportHoursPhasingData> {
    return HttpClient.get<IGlobalReportHoursPhasingData, Record<string, string>>(`${Urls.GlobalReport.reports}project-hours-phasing-table`, queryParams)
  },

  getProjectHoursPhasingChart(queryParams: Record<string, string>): Promise<IReportChart> {
    return HttpClient.get<IReportChart, Record<string, string>>(`${Urls.GlobalReport.reports}project-hours-phasing-chart`, queryParams)
  },

  getExpectedPaymentsFilterData(): Promise<IProjectList> {
    return HttpClient.get<IProjectList, null>(`${Urls.GlobalReport.reports}expected-payments-filter`)
  },

  getExpectedPayments(queryParams: Record<string, string>): Promise<IGlobalReportExpectedPaymentsData> {
    return HttpClient.get<IGlobalReportExpectedPaymentsData, Record<string, string>>(`${Urls.GlobalReport.reports}expected-payments-table`, queryParams)
  },

  getExpectedPaymentsChart(queryParams: Record<string, string>): Promise<IReportChart> {
    return HttpClient.get<IReportChart, Record<string, string>>(`${Urls.GlobalReport.reports}expected-payments-chart`, queryParams)
  },

  getExpectedReceiptsFilterData(): Promise<IProjectList> {
    return HttpClient.get<IProjectList, null>(`${Urls.GlobalReport.reports}expected-receipts-filter`)
  },

  getExpectedReceipts(queryParams: Record<string, string>): Promise<IGlobalReportExpectedPaymentsData> {
    return HttpClient.get<IGlobalReportExpectedPaymentsData, Record<string, string>>(`${Urls.GlobalReport.reports}expected-receipts-table`, queryParams)
  },

  getExpectedReceiptsChart(queryParams: Record<string, string>): Promise<IReportChart> {
    return HttpClient.get<IReportChart, Record<string, string>>(`${Urls.GlobalReport.reports}expected-receipts-chart`, queryParams)
  },

  exportTasksByProject(queryParams?: Record<string, string>): Promise<Blob | AxiosResponse<Blob>> {
    return HttpClient.downloadFile<Record<string, string>>(`${Urls.GlobalReport.reports}export-tasks-by-project"`, queryParams)
  },

  exportFTEbyProject(queryParams?: Record<string, string>): Promise<Blob | AxiosResponse<Blob>> {
    return HttpClient.downloadFile<Record<string, string>>(`${Urls.GlobalReport.reports}export-fte-by-project"`, queryParams)
  },

  exportExpenditurePhasing(queryParams?: Record<string, string>): Promise<Blob | AxiosResponse<Blob>> {
    return HttpClient.downloadFile<Record<string, string>>(`${Urls.GlobalReport.reports}export-expenditure-phasing`, queryParams)
  },

  exportProjectHoursPhasing(queryParams?: Record<string, string>): Promise<Blob | AxiosResponse<Blob>> {
    return HttpClient.downloadFile<Record<string, string>>(`${Urls.GlobalReport.reports}export-project-hours-phasing`, queryParams)
  },

  exportProjectList(queryParams?: Record<string, string>): Promise<Blob | AxiosResponse<Blob>> {
    return HttpClient.downloadFile<Record<string, string>>(`${Urls.GlobalReport.reports}export-project-list"`, queryParams)
  },

  exportExpectedPayments(queryParams?: Record<string, string>): Promise<Blob | AxiosResponse<Blob>> {
    return HttpClient.downloadFile<Record<string, string>>(`${Urls.GlobalReport.reports}export-expected-payments"`, queryParams)
  },

    exportExpectedReceipts(queryParams?: Record<string, string>): Promise<Blob | AxiosResponse<Blob>> {
    return HttpClient.downloadFile<Record<string, string>>(`${Urls.GlobalReport.reports}export-expected-receipts"`, queryParams)
  },

  exportDepartmentUtilization(queryParams?: Record<string, string>): Promise<Blob | AxiosResponse<Blob>> {
    return HttpClient.downloadFile<Record<string, string>>(`${Urls.GlobalReport.reports}export-department-utilization"`, queryParams)
  },
}
